import { render } from "./RedocPreviewer.vue?vue&type=template&id=83334704&scoped=true"
import script from "./RedocPreviewer.vue?vue&type=script&lang=js"
export * from "./RedocPreviewer.vue?vue&type=script&lang=js"

import "./RedocPreviewer.vue?vue&type=style&index=0&id=83334704&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83334704"]])

export default __exports__